import { PillButton } from "@/components/Button/PillButton";
import { EditSvg } from "@/components/Icon/Icon";
import { TEMPLATE_TABLE_STATE_NAME } from "@/constants/templates";
import { EditTemplateModal } from "@/pages/Home/DesignSection/AssembledTabsSection/EditTemplateModal/EditTemplateModal";
import { changeTemplate } from "@/pages/Home/DesignSection/AssembledTabsSection/EditTemplateModal/utils";
import { clientApi } from "@/store/clientApi";
import { selectCheckedIds, selectRtkData } from "@/store/slices/tableSlice";
import { RootState } from "@/store/store";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const EditTemplateButton = () => {
  const { t } = useTranslation();
  const [openEditTemplateModal, setOpenEditTemplateModal] = useState(false);
  const selectedTemplate = useSelector((state: RootState) => {
    const templates = selectRtkData(state, TEMPLATE_TABLE_STATE_NAME, clientApi.endpoints.getTemplatesApiV1TemplatesGet.select);
    const checkedIds = selectCheckedIds(state, TEMPLATE_TABLE_STATE_NAME);
    if (checkedIds.length !== 1) {
      return undefined;
    }

    return templates?.data?.content?.find((template) => template.id.toString() === checkedIds[0]);
  });

  const handleEditTemplate = () => {
    if (selectedTemplate === undefined) {
      return;
    }

    setOpenEditTemplateModal(true);
    changeTemplate(selectedTemplate);
  };

  return (
    <>
      <PillButton disabled={selectedTemplate === undefined} onClick={handleEditTemplate} startIcon={<EditSvg color="inherit" />}>
        {t("common:button.edit")}
      </PillButton>
      <EditTemplateModal open={openEditTemplateModal} setOpen={setOpenEditTemplateModal} action={"edit"} />
    </>
  );
};
